/** Ekran KDS zwracany przez `v3-listKdsDevices` (bez pól wrażliwych). */
export interface KdsDevice {
  deviceId: string;
  name: string | null;
  roomServiceId: string | null;
  model: string | null;
  appVersion: string | null;
  /** Milisekundy epoki albo null, gdy backend nie ma jeszcze znacznika. */
  pairedAt: number | null;
  lastSeenAt: number | null;
}

/** Koperta odpowiedzi v3 (`{success, message, data}`). */
export interface KdsEnvelope<T> {
  success: boolean;
  message: string;
  data: T;
}

export interface ClaimKdsDeviceRequest {
  hotelId: string;
  code: string;
  name?: string;
  roomServiceId?: string | null;
}

export interface ClaimKdsDeviceResult {
  deviceId: string;
  name: string;
  hotelId: string;
  roomServiceId: string | null;
}

export interface UnpairKdsDeviceRequest {
  hotelId: string;
  deviceId: string;
}

/**
 * Po ilu milisekundach bez kontaktu uznajemy ekran za offline. Tablet stempluje
 * `lastSeenAt` przy każdym odpytaniu o stan parowania (co kilkadziesiąt sekund),
 * więc pięć minut ciszy to już realna awaria, a nie chwilowe zacięcie sieci.
 */
export const KDS_ONLINE_THRESHOLD_MS = 5 * 60 * 1000;

export const isKdsDeviceOnline = (lastSeenAt: number | null): boolean => typeof lastSeenAt === 'number' && Date.now() - lastSeenAt < KDS_ONLINE_THRESHOLD_MS;
